/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { TransactionResponseDto } from '../models/transaction-response-dto';
import { transactionsControllerFilterTransactions } from '../fn/transactions/transactions-controller-filter-transactions';
import { TransactionsControllerFilterTransactions$Params } from '../fn/transactions/transactions-controller-filter-transactions';
import { transactionsControllerGetTransactionById } from '../fn/transactions/transactions-controller-get-transaction-by-id';
import { TransactionsControllerGetTransactionById$Params } from '../fn/transactions/transactions-controller-get-transaction-by-id';
import { TransactionsListResponseDto } from '../models/transactions-list-response-dto';

@Injectable({ providedIn: 'root' })
export class TransactionsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `transactionsControllerFilterTransactions()` */
  static readonly TransactionsControllerFilterTransactionsPath = '/keus-payments/transactions/filter';

  /**
   * Filter transactions.
   *
   * Filter transactions using various criteria including tenant, status, amount, date range, etc.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transactionsControllerFilterTransactions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transactionsControllerFilterTransactions$Response(params: TransactionsControllerFilterTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionsListResponseDto>> {
    return transactionsControllerFilterTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter transactions.
   *
   * Filter transactions using various criteria including tenant, status, amount, date range, etc.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transactionsControllerFilterTransactions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transactionsControllerFilterTransactions(params: TransactionsControllerFilterTransactions$Params, context?: HttpContext): Observable<TransactionsListResponseDto> {
    return this.transactionsControllerFilterTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionsListResponseDto>): TransactionsListResponseDto => r.body)
    );
  }

  /** Path part for operation `transactionsControllerGetTransactionById()` */
  static readonly TransactionsControllerGetTransactionByIdPath = '/keus-payments/transactions/{id}';

  /**
   * Get transaction by ID.
   *
   * Retrieve a specific transaction by its payment intent ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transactionsControllerGetTransactionById()` instead.
   *
   * This method doesn't expect any request body.
   */
  transactionsControllerGetTransactionById$Response(params: TransactionsControllerGetTransactionById$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionResponseDto>> {
    return transactionsControllerGetTransactionById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get transaction by ID.
   *
   * Retrieve a specific transaction by its payment intent ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transactionsControllerGetTransactionById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  transactionsControllerGetTransactionById(params: TransactionsControllerGetTransactionById$Params, context?: HttpContext): Observable<TransactionResponseDto> {
    return this.transactionsControllerGetTransactionById$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionResponseDto>): TransactionResponseDto => r.body)
    );
  }

}
